// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6d6af96","732":"693911a2","977":"46bec143"}[chunkId] + ".chunk.js";
};